import { render, staticRenderFns } from "./FirebaseNotification.vue?vue&type=template&id=80b816fa"
import script from "./FirebaseNotification.vue?vue&type=script&lang=js"
export * from "./FirebaseNotification.vue?vue&type=script&lang=js"
import style0 from "./FirebaseNotification.vue?vue&type=style&index=0&id=80b816fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports